import { Search, StarFill } from "react-bootstrap-icons";
import Searchpage from "./Searchpage.js";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

export default function Homepage () {
    const navigate = useNavigate();

    function Searchpage() {
        navigate("/searchpage")
    }
    return (
       <h1>
        <StarFill onClick={Searchpage} className="five-points-star"></StarFill>
    
       </h1> 
    ) 
}